export const selectMemberDetails = state => state.memberDetails.data || {};

export const selectHasMemberDetails = state => !!selectMemberDetails(state).Memberships?.length;
